import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flag'
})
export class FlagPipe implements PipeTransform {

  transform(value: any, args?: any): any {
      if(value.length > 0){
          let lang = value.toLowerCase();
          return '<img src="assets/img/flags/' + lang +  '.png" />';
      }
      else{
          return 'ALL';
      }
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/flag.pipe.ts